import { useEffect, useLayoutEffect, useRef } from 'react'

type Params = {
  value: string
  max: number
  onPress: (val: string) => void
}

// web: даём вводить pin с физической клавиатуры (цифры + Backspace), а не только кликами по кнопкам.
export function usePinKeyboard({ value, max, onPress }: Params) {
  const valueRef = useRef(value)
  const optionsRef = useRef({ max, onPress })

  useLayoutEffect(() => {
    valueRef.current = value
  }, [value])

  useLayoutEffect(() => {
    optionsRef.current = { max, onPress }
  }, [max, onPress])

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      const options = optionsRef.current

      if (/^[0-9]$/.test(event.key)) {
        if (valueRef.current.length >= options.max) return

        // Следующая клавиша может прийти до рендера с обновлённым value.
        valueRef.current += event.key
        options.onPress(valueRef.current)
        return
      }

      if (event.key === 'Backspace') {
        event.preventDefault()
        valueRef.current = valueRef.current.slice(0, -1)
        options.onPress(valueRef.current)
      }
    }

    window.addEventListener('keydown', handler)

    return () => window.removeEventListener('keydown', handler)
  }, [])
}
